import request from '@/utils/request'

// 保存手续文件
export function savePrjprocedures(data) {
    return request({
      url: 'admin/portal/prjprocedures/save',
      method: 'post',
      data
    })
  }

  export function addSelectInit() {
    return request({
      url: 'admin/portal/prjprocedures/init',
      method: 'post'
    })
  }

/**
 * 手续文件列表
 */
export function getProceduresList(data) {
  return request({
    url: 'admin/portal/prjprocedures/list',
    method: 'post',
    data
  })
}
  
/**
 * 批量删除手续
 */
 export function delProcedures(data) {
  return request({
    url: 'admin/portal/prjprocedures/del',
    method: 'post',
    data
  })
}